import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import decode from 'jwt-decode';
import Carousel from "../../component/carousel";
import { authUser,setFirebaseToken, privacyNoticeUpdate } from "../../services/API"
import { setNamaPerusahaan, setUser } from "../../core/local-storage";
import { setEmail as setEmailAddress, setOtp,setFirstLogin } from "../../core/local-storage";
import { setTelp } from "../../core/local-storage";
import { setId } from "../../core/local-storage";
import NavbarLogin from "../../component/navbar";
import Footer from "../../component/footer";
import {
    settoken,setrefreshtoken
} from '../../services/fetchTools';
import FiturCard from "./component/fitur-card";
import ConfirmAlert from "../../component/alert/confirmAlert";
import LoadingAlert from "../../component/alert/loadingAlert";
import PrivacyAlert from "../../component/alert/privacyAlert";
import submitPrivacyAlert from "../../component/alert/submitPrivacyAlert";
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { getEQByCodeWithoutAuth } from "../../services/API/mod_request";
import auth from "../../services/auth";

import iCareLogo from '../../images/iCareLogo.png';
import banner1 from '../../images/Cahyo_MFD.png';
import fitur1 from '../../images/breakfix-fitur.png';
import fitur2 from '../../images/supplies-fitur.png';
import fitur3 from '../../images/collect-meter-install.png';
import fitur4 from '../../images/riwayat.png';
import fitur5 from '../../images/informasi.png';
import fitur6 from '../../images/setting.png';
import profit1 from '../../images/easy.png'
import profit2 from '../../images/monitoring.png'
import profit3 from '../../images/quality.png'
import profit4 from '../../images/satisfaction.png'
import peta from '../../images/peta.png'
import backroundLogin from '../../images/Vector1.png'
import googleIcons from "./../../images/google-icons.png"
import captchaBackground from '../../images/captcha-background.jpg';
import privacyNotice from '../../files/Privacy Notice AG.pdf'
import privacyPolicy from '../../files/Privacy Policy_AG.pdf'

// import Cookies from "universal-cookie";
import { appConfig } from "../../config";
import OtpAlert from "../../component/alert/otpAlert";
import SubmitPrivacyAlert from "../../component/alert/submitPrivacyAlert";


function Login ({getToken}) {
    
    // constructor(props) {
        // super(props)
    const navigate = useNavigate();
    // const cookies = new Cookies()
        // this.submit = this.submit.bind(this)
        // this.handlePopup = this.handlePopup.bind(this)
        // this.inputChange = this.inputChange.bind(this)
        const [alertOption, setAlertOption] = useState({
                                                    title:'',
                                                    message:''
                                                })
	    // const [username, setUsername]= useState('')
        const [password, setPassword]= useState('')
        const [loading, setLoading]= useState(false) 
        const [error, setError]= useState(false)
        // const [errMsg, setErrMsg]= useState('')
        // const [login, setLogin]= useState(false)
        const [showPopup, setShowPopup]= useState(false)
        const [privacyPolicyShow, setPrivacyPolicyShow]= useState(false)
        const [privacyNoticeShow, setPrivacyNoticeShow]= useState(false)
        const [showPermissionPopup, setShowPermissionPopup]= useState(false)
        const [submitPrivacyPopup, setSubmitPrivacyPopup]= useState(false)
        const [email, setEmail]= useState('')
        const [errorEmail, setErrorEmail]= useState('')
        const [errorPassword, setErrorPassword]= useState('')
        const [equipment, setEquipment] = useState([])
        const [showPassword, setShowPassword] = useState(false)
        const [captcha, setCaptcha]= useState('')
        const [captchaVal, setCaptchaVal]= useState('')
        const [errorCaptcha, setErrorCaptcha]= useState('')
        const [showPopupOTP, setShowPopupOTP]= useState(false)
        const [jenisOTP, setJenisOTP]= useState('')
        const [errorJenisOTP, setErrorJenisOTP]= useState('')
        const [isEmailVerified, setIsEmailVerified] = useState(false)
        const [isWhatsappVerified, setIsWhatsappVerified] = useState(false)
        const [tipeLogin, setTipeLogin]= useState('')
        const [tmpGoogleToken, setTmpGoogleToken]= useState('')
        const [isCheck, setIsCheck] = useState(true)
        const [errorUpdatePrivacy, setErrorUpdatePrivacy]= useState('')
        const [tmpToken, setTmpToken]= useState('')

        const fiturData= [
                {
                    lg: 3,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    imgHeight: 140,
                    borderColor: '#2DB5F9',
                    img: fitur1,
                    title: 'Breakfix',
                    description: 'Sebagai layanan customer untuk permintaan perbaikan pada mesin.'
                },
                {
                    lg: 3,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    imgHeight: 140,
                    borderColor: '#F58B09',
                    img: fitur2,
                    title: 'Supplies',
                    description: 'Sebagai layanan customer untuk permintaan consumable dan sparepart.'
                },
                {
                    lg: 3,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    imgHeight: 140,
                    borderColor: '#0EDA52',
                    img: fitur3,
                    title: 'Install',
                    description: 'Sebagai layanan customer untuk permintaan setting konfigurasi mesin.'
                },
                {
                    lg: 3,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    imgHeight: 140,
                    borderColor: '#B40EDE',
                    img: fitur3,
                    title: 'Collect Meter',
                    description: 'Sebagai layanan customer untuk permintaan informasi billing meter yang ada pada mesin printer Astragraphia.'
                },
                {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    imgHeight: 70,
                    style: {marginBottom:'1.5rem', marginTop:'2rem'},
                    borderColor: '#E23845',
                    img: fitur4,
                    title: 'Riwayat',
                    description: 'Untuk melihat histori permintaan layanan sebelumnya.'
                },
                {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    imgHeight: 70,
                    style: {marginBottom:'1.5rem', marginTop:'2rem'},
                    borderColor: '#B629DD',
                    img: fitur5,
                    title: 'Informasi',
                    description: 'Untuk melihat status notifikasi dari permintaan layanan yang dibuat.'
                },
                {
                    lg: 4,
                    md: 4,
                    sm: 6,
                    xs: 12,
                    imgHeight: 70,
                    style: {marginBottom:'1.5rem', marginTop:'2rem'},
                    borderColor: '#EE31A3',
                    img: fitur6,
                    title: 'Setting',
                    description: 'Untuk melihat konfigurasi pada aplikasi iCare seperti perubahan Data Diri, Alamat, EQ, dll.'
                },

            ]
        
    // }
    const params = useParams()

    useEffect(() => {

        console.log('PROD update 2026 01 12')

        generateCaptcha()

        if(params?.id) {
            checkEQ()
        }else{
            console.log('login call isAuthenticated')
            if(auth.isAuthenticated()) {                
                navigate('/dashboard')
                return                
            }
        }
        // console.log(sessionStorage.getItem('is-open'));
        if(("Notification" in window)) {            
            if(window.Notification?.permission !== 'granted') {
                setShowPermissionPopup(true)
            }
        }
    }, [])

    const checkEQ = async () => {
        setLoading(true)
        const res = await getEQByCodeWithoutAuth(params.id)
    
        setLoading(false)
        if(auth.isAuthenticated()) {
            if(res.status == 200 && typeof res.data !== 'string') {
                var objEQ = res.data.Table[0]
                objEQ.sticker = params.id
                navigate('/dashboard', {
                    state: objEQ
                })
                return
            }
        }

        if(typeof res.data === 'string') {
            setAlertOption({ title: 'Error', message: res.data })
            setShowPopup(true)
        } else {
            setEquipment(res.data.Table[0])
        }
    }

    const handleEmailInput = (event) => {
        setEmail(event.target.value)        
        if(event.target.value === "") 
            setErrorEmail("Silahkan isi email")
        else
            setErrorEmail("")
    }

    const handleCaptchaInput = (event) => {
        setCaptcha(event.target.value)        
        if(event.target.value === "") 
            setErrorCaptcha("Silahkan isi captcha")
        else
            setErrorCaptcha("")
    }
    
   const handlePasswordInput = (event) => {
        setPassword(event.target.value) 
        if(event.target.value === "") 
            setErrorPassword("Silahkan isi password")
        else
            setErrorPassword("")
    }
    const handlePopup = ()=> {
        setShowPopup(false)
        setShowPermissionPopup(false)
        
    }
    const privacyPolicyPopUp = ()=> {
        setPrivacyPolicyShow(true)
    }
    const privacyPolicyClose = ()=> {
        setPrivacyPolicyShow(false)
    }
    const privacyNoticePopUp = ()=> {
        setPrivacyNoticeShow(true)
    }
    const privacyNoticeClose = ()=> {
        setPrivacyNoticeShow(false)
    }
    const googleLogin = async (credential)=> {
        setTipeLogin("google")
        setTmpGoogleToken("")
        setTmpToken("")
        // console.log(credential)
        const d = decode(credential.credential);
        setLoading(true)
        // console.log('decoded',d)
        const response = await authUser({
            username: d.email, password: '', type:"google",googleToken:credential.credential,otpMethod:'',token: ''
        });

        setLoading(false)
        // console.log('testingresponseLogin', response)
        // console.log('response type',typeof(response), typeof response)
        if(response.status !== 404) {
            if (response != null && (typeof(response)) === 'object') {
                setEmail(response.emailaddress)
                successlogin(response,'google', credential.credential)
            
            } else {
                setShowPopup(true)
                setAlertOption({title:"Error", message:response})
            }
        } else {
            setShowPopup(true)
            setAlertOption({title:"Error", message:'Gagal terhubung dengan sistem. Silahkan periksa kembali jaringan anda'})
        }
    }
    const loginSSO = useGoogleLogin({
        onSuccess: googleLogin
    })
    const successlogin = async (response, type='normal', googleToken=null)=> {
        if (response.isEmailVerified == true || response.isWhatsappVerified == true){
            setIsEmailVerified(response.isEmailVerified)
            setIsWhatsappVerified(response.isWhatsappVerified)
            setTmpToken(response.token)
            setTmpGoogleToken(googleToken)
            setJenisOTP("")
            if(response.isPrivacyNotice == true){
                setShowPopupOTP(true)
            } else {
                setSubmitPrivacyPopup(true)
            }
        } else if (response.action){ 
            setOtp(false)
            setFirstLogin(response)
            console.log(response);
            setShowPopup(true)
            navigate('/kode-otp',{                      
                    state: {firstlogin:true,email:email,password:password,
                    telp:response.telp,userid:response.userid,msg:response,type:type,googleToken:googleToken,jenisOTP:"email"
                    }} // your data array of objects
                ) 
        }else{
            localStorage.setItem('status_internal', response.status_internal)
            settoken(response.token)
            setrefreshtoken(response.refreshtoken)
            setUser(response.namalengkap)
            setEmailAddress(response.emailaddress)
            setTelp(response.telp)
            setNamaPerusahaan(response.namaperusahaan)
            setId(response.id)
            if(("Notification" in window)) {                
                window.Notification?.requestPermission()
                    .then(async (permission) => {
                      if (permission === 'granted') {
                        await getToken()
                    }
                })
            }

            if(params?.id && equipment) {
                // console.log('scan eq')

                localStorage.setItem('equipment',equipment)
                var objEQ = equipment
                objEQ.sticker = params.id
                navigate('/dashboard', {
                    state: objEQ
                })
            } else {
                // console.log('oke goto dashboard')
                navigate("/dashboard")
            }
        }
    }

    async function useLogin (e) {
        e.preventDefault() 

        setTipeLogin("normal")
        setTmpGoogleToken("")
        setTmpToken("")

        if(email === "" || password === "" || captcha === "") {
            setShowPopup(true)
            setAlertOption({title:"Error", message:"Form not Valid"}) 
            if(email === "") setErrorEmail("Silahkan isi email")
            if(password === "") setErrorPassword("Silahkan isi password")
            if(captcha === "") setErrorCaptcha("Silahkan isi captcha")
            return
        }

        if(captcha.toLocaleLowerCase() != captchaVal.toLocaleLowerCase()){
            setShowPopup(true)
            setAlertOption({title:"Error", message:"Captcha not Valid"}) 
            return
        }
        
        // const {username, password} = this.state 
        setShowPopup(false)
        setLoading(true)
        setError(false)
        setIsEmailVerified(false)
        setIsWhatsappVerified(false)
        const response = await authUser({
            username: email, password: password, type:"normal",otpMethod:'',token: ''
          });

        setLoading(false)

        // console.log('testingresponseLogin', response)
        // console.log('response type',typeof(response), typeof response)
        if (response != null && (typeof(response)) === 'object') {
            successlogin(response)

        // console.log('iCare_user', cookies.get('iCare_user')); // Pacman
            // this.setState({loading:false, error: false, login: true})
        // window.location.reload(false);
            
        } else {
            console.log(response);
            if(response === null) {
                setShowPopup(true)
                setAlertOption({title:"Error", message: 'Mohon periksa koneksi jaringan anda'})
            } else {
                setShowPopup(true)
                setAlertOption({title:"Error", message: response})
            }
        }
    }

    const generateCaptcha = ()=> {
        var result = '';
        var characters = 'abcdefghjkmnopqrstuvwxyz023456789';
        var charactersLength = characters.length;
        for (var i = 0; i < 6; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        setCaptchaVal(result)
    }

    const closeOTP = () => {
        setShowPopupOTP(false)
    }

    async function kirimOTP () {
        console.log('kirimOTP jenisOTP ', jenisOTP)

        let isValid = true
        if(jenisOTP == "")
        {
            setErrorJenisOTP("Silahkan pilih jenis OTP")
            isValid = false
        }
        else
        {
            setErrorJenisOTP("")
        }

        if(isValid)
        {
            setShowPopupOTP(false)
            setLoading(true)
            setError(false)

            const response = await authUser({
                username: email, password: password, type:tipeLogin,otpMethod:jenisOTP,token: '',googleToken: tipeLogin == "google" ? tmpGoogleToken :''
            });
            setLoading(false)

            if (response != null && (typeof(response)) === 'object') {
                setOtp(false)
                setFirstLogin(response)
                var message = {action : jenisOTP == 'email' ? 'Login OTP Email' : 'Login OTP Whatsapp', email: email}
                navigate('/kode-otp',{                      
                        state: {firstlogin:true,email:response.emailaddress,password:password,
                        telp:response.telp,userid:response.userid,msg:message,type:tipeLogin,jenisOTP:jenisOTP,googleToken:tmpGoogleToken
                        }}
                    )              
            } else {
                console.log(response);
                if(response === null) {
                    setShowPopup(true)
                    setAlertOption({title:"Error", message: 'Mohon periksa koneksi jaringan anda'})
                } else {
                    setShowPopup(true)
                    setAlertOption({title:"Error", message: response})
                }
            }
        }
    }

    async function updatePrivacy () {
        console.log("updatePrivacy")

        setErrorUpdatePrivacy("")

        const res = await privacyNoticeUpdate(tmpToken)
        console.log("updatePrivacy res ", res)

        if(res){
            setSubmitPrivacyPopup(false)
            setShowPopupOTP(true)
        } else {
            setErrorUpdatePrivacy("Gagal Submit")
        }
    }
    
        return(
            <>
            <NavbarLogin />
                <div className="container py-4 py-xs-0" id="layout">                    
            <div className="intro-y">
                {/* Beranda */}
                <div className="d-lg-block d-none" style={{ background: `url(${backroundLogin})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, zIndex: -1 }} id="beranda"></div>

                <div className="d-flex align-items-center row-height" style={{ height: '85vh' }}>
                    <div className="col-lg-6 col-md-8 col-sm-10 col-12 mx-lg-0 mx-auto">
                        <div className="card shadow-sm" style={{border:'1px solid #a2d2ff'}}>
                            <div className="card-body px-4 py-5">
                                <div className="col-12 text-center mb-3">
                                    <img src={iCareLogo} alt="Logo iCare" className="h-50 login-image"/>
                                </div>
                                <form onSubmit={ useLogin }>
                                    <div className="mb-3">
                                        <label className="size-13px fw-bold">EMAIL</label>
                                        <input type="text"  name="username"  onChange={handleEmailInput} autoComplete="email" className={`form-control border-only-bottom ${ errorEmail !== "" ? "is-invalid" : ""}`}/>
                                        <span className={`invalid-feedback ${errorEmail === "" ? "d-none": ""}`} style={{ fontSize: 12 }}>{errorEmail}</span>
                                    </div>
                                    <div className="mb-4">
                                        <label className="size-13px fw-bold">PASSWORD</label>
                                        <div className="input-group">
                                            <input type={showPassword ? 'text' : 'password'}  name="password" onChange={handlePasswordInput} autoComplete="password" className={`form-control border-only-bottom ${ errorPassword !== "" ? "is-invalid" : ""}`}/>
                                            <div className="input-group-append">
                                                <div className="input-group-text bg-white border-0" onClick={() => setShowPassword(!showPassword)}>
                                                    <i className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'} style={{fontSize: '18px', color: '#014C90'}}></i>
                                                </div>
                                            </div>
                                        </div>
                                        <span className={`invalid-feedback ${errorPassword === "" ? "d-none": ""}`} style={{ fontSize: 12 }}>{errorPassword}</span>
                                    </div>

                                    {/* style={{ backgroundImage: captchaBackground }} */}
                                    <div className="captcha-container">
                                        <div className="captcha" style={{ userSelect: "none" }}>{ captchaVal }</div>
                                        <button className="refresh-btn" type="button" onClick={generateCaptcha}>
                                            <i className="fa fa-refresh" style={{fontSize: '18px', color: '#ffffff'}}></i>
                                        </button>
                                    </div>

                                    <div className="mb-3">
                                        <label className="size-13px fw-bold">CAPTCHA</label>
                                        <input type="text"  name="captcha"  onChange={handleCaptchaInput} className={`form-control border-only-bottom ${ errorCaptcha !== "" ? "is-invalid" : ""}`}/>
                                        <span className={`invalid-feedback ${errorCaptcha === "" ? "d-none": ""}`} style={{ fontSize: 12 }}>{errorCaptcha}</span>
                                    </div>
                                    <div className="mb-2 mx-auto text-center">
                                        <p style={{fontSize: '14px'}}>Dengan Login saya menyetujui <button className="popup-btn btn" type="button" onClick={()=> window.open("https://astragraphia.co.id/id/pemberitahuan-privasi", "_blank")}>Pemberitahuan Privasi</button> 
                                            {/* <button className="popup-btn btn" type="button" onClick={privacyNoticePopUp}>
                                            Kebijakan Privacy Notice </button> & <button className="popup-btn btn" type="button" onClick={privacyPolicyPopUp}>
                                            Kebijakan Privacy Policy AG Group</button> */}
                                        </p>
                                    </div>
                                    <div className="mb-2 mx-auto text-center">
                                        <button className="btn btn-login my-1" style={{paddingLeft:'70px', paddingRight:'70px', paddingBottom:'10px', paddingTop:'10px'}}>LOGIN</button>
                                    </div>
                                    <div className="text-center">
                                        <Link className="size-13px fw-medium my-2" style={{textDecoration: 'none'}} to="/kebijakan-privasi/register">Belum Punya akun ?</Link><br/>
                                        <Link className="size-13px fw-medium my-2 mb-3" style={{textDecoration: 'none'}} to="/lupa-password">Lupa Password ?</Link><br/>
                                        <div className="btn btn-google shadow-sm me-2 mt-4 fw-medium px-3 text-muted py-1">
                                        <GoogleLogin 
                                            onSuccess={credentialResponse => {
                                              googleLogin(credentialResponse);
                                            }}
                                          
                                            onError={() => {
                                              console.log('Login Failed');
                                            }}
                                          
                                          />
                                          </div>
                                        {/* <button type="button" className="btn btn-google shadow-sm me-2 fw-medium px-3 text-muted py-1 mt-4" onClick={ loginSSO } >
                                            <img src={ googleIcons } alt="google-icons" height="20" className="me-3" />
                                            Sign in with Google
                                        </button> */}
                                    </div>
                                </form>
                                <PrivacyAlert visible={privacyNoticeShow} titleMessage="Privacy Notice" file={privacyNotice} onClick={privacyNoticeClose}></PrivacyAlert>
                                <PrivacyAlert visible={privacyPolicyShow} titleMessage="Privacy Policy" file={privacyPolicy} onClick={privacyPolicyClose}></PrivacyAlert>
                                <ConfirmAlert visible={showPopup} titleMessage={alertOption.title} message={alertOption.message} onClick={handlePopup} customClass="col-md-3 col-sm-4 col-8" />
                                <LoadingAlert visible={loading} customClass="col-md-2 col-sm-4 col-8"  />
                                <ConfirmAlert visible={showPermissionPopup} titleMessage="Permintaan Perizinan" message="Mohon setujui permintaan perizinan agar aplikasi dapat berjalan dengan baik" customClass="col-md-5 col-10" onClick={handlePopup} />
                                <OtpAlert visible={showPopupOTP} customClass={`col-3 ${showPopupOTP ? 'information-popup' : ''}`} closeOTP={closeOTP} jenisOTP={jenisOTP} errorJenisOTP={errorJenisOTP} setJenisOTP={setJenisOTP} kirimOTP={kirimOTP} setErrorJenisOTP={setErrorJenisOTP} isEmailVerified={isEmailVerified} isWhatsappVerified={isWhatsappVerified}/>
                                <SubmitPrivacyAlert visible={submitPrivacyPopup} customClass="col-sm-6 max-w-88" isCheck={isCheck} setIsCheck={setIsCheck} updatePrivacy={updatePrivacy} errorUpdatePrivacy={errorUpdatePrivacy}/>
                            </div>
                            <div className="d-flex flex-row-reverse w-100 mr-6">                        
                                <div className="m-2 inline-block" style={{whiteSpace:'nowrap', fontSize:'14px'}}>{ appConfig.VERSION }</div>                        
                            </div>
                        </div>

                    </div>
                    <div className="col-4 ms-auto d-lg-block d-none">
                        <img src={banner1} alt="images 1" width="80%" className="mb-3" style={{marginLeft:'70px'}}/>
                        <h2 className="title-icare title-solusi text-center fw-bold" style={{marginLeft:'70px', fontSize:'35px'}}>Solusi untuk eskalasi problem dan permintaan layanan.</h2>
                    </div>
                </div>

                {/* About */}
                <section className="section-about py-5 my-5 d-lg-block d-none" id="about">
                    <div className="row">
                        <div className="card-about col-5 p-0 ms-auto">
                            <div className="card-body py-5 px-3 mx-5">
                                <h3 className="title-icare text-center fw-bold mb-5">Mengapa iCare?</h3>
                                <p className="card-text description-icare lh-sm" style={{fontSize:'14px'}}>iCare adalah aplikasi mobile yang dapat digunakan untuk mempermudah <b>eskalasi problem</b> dan <b>permintaan layanan</b> yang dibutuhkan oleh pelanggan Astragraphia.</p>
                            </div>
                        </div>
                        <div className="col-6 p-0 me-auto">
                            <iframe width="100%" height="255" src="https://www.youtube-nocookie.com/embed/WthGEU-Rig4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                        </div>
                    </div>
                </section>

                {/* Features */}
                <section className="section-fitur d-lg-block d-none" id="fitur">
                    <div className="container mb-5">
                        <h3 className="title-icare text-center fw-bold mb-5"> Fitur iCare</h3>
                        <FiturCard data={fiturData} />
                    </div>
                </section>

                {/* Profit */}
                <section className="benefit-section d-lg-block d-none" id="benefit">
                    <div className="container pt-5 mb-5">
                        <h3 className="title-icare text-center fw-bold mb-5">Keuntungan</h3>
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="card custom-height shadow-lg mb-5">
                                    <div className="card-body d-flex align-items-center justify-content-center" style={{padding:'5rem 3rem'}}>
                                        <div className="text-center">
                                            <img src={profit1} alt="riwayat" width="50" />
                                            <h5 className="card-title mt-3 fw-bold"> Riwayat </h5>
                                            <p className="card-text" style={{fontSize:'14px'}}>Memudahkan customer pada saat permintaan layanan.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="card custom-height shadow-lg mb-5">
                                    <div className="card-body d-flex align-items-center justify-content-center" style={{padding:'5rem 3rem'}}>
                                        <div className="text-center">
                                            <img src={profit2} alt="monitoring" width="50" />
                                            <h5 className="card-title mt-3 fw-bold"> Monitoring </h5>
                                            <p className="card-text" style={{fontSize:'14px'}}>Customer dapat memonitor status permintaan layanan.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="card custom-height shadow-lg mb-5">
                                    <div className="card-body d-flex align-items-center justify-content-center" style={{padding:'5rem 3rem'}}>
                                        <div className="text-center">
                                            <img src={profit3} alt="setting" width="50" />
                                            <h5 className="card-title mt-3 fw-bold"> Settings </h5>
                                            <p className="card-text" style={{fontSize:'14px'}}>Meningkatkan kualitas layanan Astragraphia.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="card custom-height shadow-lg mb-5">
                                    <div className="card-body d-flex align-items-center justify-content-center" style={{padding:'5rem 3rem'}}>
                                        <div className="text-center">
                                            <img src={profit4} alt="satisfaction" width="50" />
                                            <h5 className="card-title mt-3 fw-bold "> Satisfaction </h5>
                                            <p className="card-text" style={{fontSize:'14px'}}>Meningkatkan kepuasan pelanggan.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Testimonial */}
                <section className="testimonials-section d-lg-block d-none" id="testimonial">
                    <div className="container pt-5 mb-5">
                        <h3 className="title-icare text-center fw-bold">Testimonials</h3>
                        <Carousel />
                    </div>
                </section>

                {/* Use iCare Now */}
                <div className="row d-lg-flex d-none" style={{borderTop: '1px solid #d4d8ff', marginTop: '6rem'}}>
                    <div className="col-lg-5 col-md-5 col-12 py-5">
                        <img src={iCareLogo} alt="Logo iCare" className="mb-2" width="150" />
                        <p className="mb-1" style={{fontSize:'28px'}}>Pakai iCare Sekarang!</p>
                        <p className="text-danger" style={{fontSize:'14px'}}>Kemudahan <b>eskalasi problem</b> dan <b>permintaan layanan</b> dalam satu genggaman.</p>
                    </div>
                    <div className="col-lg-7 col-md-7 col-12">
                        <div className="container">
                            <img src={peta} alt="iCare" height="260" />
                        </div>
                    </div>
                </div>
                <p className="cp-mobile text-center d-md-none d-block">iCare &copy; PT ASTRA GRAPHIA TBK</p>
            </div>

        </div>
        <Footer />
        </>
        )
    
    

    
    
}
export default Login
